import logo from '../images/logo.png'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Image from 'react-bootstrap/Image'
import Container from 'react-bootstrap/Container'
import './navigation.css'

export function Navigation() {
    return(
        <div>
              
                         <Navbar expand="lg">
                        <Navbar.Brand >
                        <Image id="logonav" src={logo} alt="logo"></Image>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav>
                                <Nav.Link href="/" className="nav-item">Home</Nav.Link>
                                <Nav.Link href="microgreens" className="nav-item">Shop All</Nav.Link>
                                <Nav.Link href="about" className="nav-item">About Us</Nav.Link>
                                <Nav.Link href="recipes" className="nav-item">Recipes</Nav.Link>
                                <Nav.Link href="contact" className="nav-item">Contact Us</Nav.Link>
                                <Nav.Link href="delivery" className="nav-item">Delivery/Pick-up</Nav.Link>
                                <Nav.Link href="commercial" className="nav-item">Restraunts/Stores</Nav.Link>
                                <Nav.Link href="events" className="nav-item">Events</Nav.Link>
                                <Nav.Link href="faq" className="nav-item">FAQ's</Nav.Link>
                                {/*<Nav.Link href="cart" className="nav-item"><ShoppingCart size={30}/><Badge>{cartItems.length}</Badge></Nav.Link>*/}
                                {/*<Nav.Link href="cart" className="nav-item">Cart</Nav.Link>*/}
                            </Nav>
                        </Navbar.Collapse>
                       
                         </Navbar>
        </div>
    )   
}

